/* -----------------Child components--------------- */
import CustomAppbar from "components/CustomAppbar";

import { pageViewTypes } from "@constants/tracking";
import ProfileContainer from "@features/dashboard/screens/ProfileContainer";
/* -----------------Types--------------- */
import useAnalytics from "@hooks/useAnalytics";
import useClerkUser from "@hooks/useClerkUser";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";

const ProfileRoute = () => {
	const { username } = useClerkUser();
	const userName = username;

	const { isMobile } = useDevice();
	useAnalytics({
		type: pageViewTypes.profile,
	});

	return (
		<>
			<CustomAppbar
				showCommandBar={false}
				showHambugerMenu
				back
				options={{
					headerTitle: userName ?? "",
					subtitle: isMobile ? "" : "Your profile",
				}}
			/>
			<DocumentTitle title="Profile" />
			<ProfileContainer />
		</>
	);
};

export default ProfileRoute;
